/* eslint-disable no-useless-escape */
/* -------------------------------------------------------------------------- */
/*                                    REGEX                                   */
/* -------------------------------------------------------------------------- */

export const REGEX_EMAIL =
	/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const REGEX_TOKEN =
	/^[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+$/;

export const REGEX_LINKEDIN =
	/^(https?:\/\/)?(www\.)?(linkedin\.com\/(company)\/[a-zA-Z0-9-._~:\/?#[\]@!$&'()*+,;=%]*)?$/;

export const REGEX_X =
	/^(https:\/\/(www\.)?x\.com\/[a-zA-Z0-9-_]+)?$/;

export const REGEX_WEBSITE =
	/^(https?:\/\/)?(www\.)?[a-zA-Z0-9-]+(\.[a-zA-Z]{2,})(\/[^\s]*)?$|^$/;

export const REGEX_VALID_TEXT = /^(?!.*\S{45,}).*$/s;

export const REGEX_VALID_NAME = /^(?!.*\S{20,}).*$/;

export const REGEX_VALID_PLACE = /^(?!.*\S{20,}).*$/;

export const REGEX_VALID_RICH_TEXT =
	/<[A-Za-z\s]+>\s*(?!\s*$).+<\/[A-Za-z\s]+>/;

export const REGEX_VALID_PARAGRAPHE_RICH_TEXT =
	/<([A-Za-z\s]+)>\s*(?!.*\S{45,}).*[^<\s].*[^<\s]\s*<\/\1>/;

export const REGEX_HTML = /<\/?[a-z][\s\S]*>/i;

export const REGEX_NUMERIC_FORMAT =
	/\B(?=(\d{3})+(?!\d))/g;

export const REGEX_PHONE_NUMBER = /^(\+\d{10,15})?$/;

export const REGEX_STRING = /^\S.{1,}$/;
